import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  className?: string;
}
export function FadeIn({
  children,
  delay = 0,
  direction = 'up',
  className = ''
}: FadeInProps) {
  const directions = {
    up: {
      y: 20,
      x: 0
    },
    down: {
      y: -20,
      x: 0
    },
    left: {
      x: 20,
      y: 0
    },
    right: {
      x: -20,
      y: 0
    },
    none: {
      x: 0,
      y: 0
    }
  };
  return <motion.div initial={{
    opacity: 0,
    ...directions[direction]
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-180" data-mp="2uvh7ayqg1lxu">
      {children}
    </motion.div>;
}
export function StaggerContainer({
  children,
  className = '',
  delay = 0
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}) {
  return <motion.div initial="hidden" whileInView="show" viewport={{
    once: true,
    margin: '-50px'
  }} variants={{
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: delay
      }
    }
  }} className={className} data-id="element-181" data-mp="3r3j3rkj3e35t">
      {children}
    </motion.div>;
}
export function StaggerItem({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <motion.div variants={{
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  }} className={className} data-id="element-182" data-mp="3d7xhvm85nzhm">
      {children}
    </motion.div>;
}